export default "__VITE_ASSET__CUtvQ0eL__"